import { Injectable } from '@angular/core';
import { RegisterData } from '../register/interfaces/register-data.interface';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageDataService {

  constructor() {

  }



  // Guardar datos en sessionStorage
  saveData(key: string, valFormRegis: RegisterData) {
    sessionStorage.setItem(key, JSON.stringify(valFormRegis));
    this.startTimer(key);
  }

  // Recuperar datos de sessionStorage
  getData(key: string): any | null {
    const value = sessionStorage.getItem(key);
    return value ? JSON.parse(value) : null; // Convertir de JSON a objeto
  }

  // Eliminar datos de sessionStorage
  removeData(key: string) {
    sessionStorage.removeItem(key);
  }

  // Limpiar todos los datos
  clearData() {
    sessionStorage.clear();
  }


  // Método para iniciar el temporizador
  startTimer(key: string) {
    // 15 minutos en milisegundos
    const fifteenMinutes = 10 * 60 * 1000;

    setTimeout(() => {
      this.removeData(key);
    }, fifteenMinutes);
  }


}
